import NumberFormat from 'react-number-format';

const FormattedNumberComponent = ({ className = '', value }) => {
  return <NumberFormat className={className} value={value} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} />;
};

export { FormattedNumberComponent as FormattedNumber };
